export default "__VITE_ASSET__CRbSLlh4__"